import { instance } from "apis/interceptor";
import * as Sentry from "@sentry/react";

type ResponseType<T> = {
    success: boolean;
    statusCode?: number;
    message?: string;
    data?: T;
};

export type TKakaoAlimContent = {
    address: string;
    addressForMap: string;
    directionsHtmlInKoreanFormat: string;
    additionalInfosHtmlInKoreanFormat: string;
    directionsHtmlInEnglishFormat: string;
    additionalInfosHtmlInEnglishFormat: string;
};

//INFO: (new) Visitors 알림톡 설정 정보 조회
export const getKakaoAlimTalkContent = async (): Promise<ResponseType<TKakaoAlimContent>> => {
    try {
        const res = await instance.get("/visitors/setting/kakao-alimtalk");
        return { success: true, data: res.data };
    } catch (error) {
        Sentry.captureException(error);
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
    }
};

//INFO: (new) Visitors 알림톡 설정 정보 수정
export const updateKakaoAlimTalkContent = async (data: TKakaoAlimContent): Promise<ResponseType<boolean>> => {
    try {
        const res = await instance.patch("/visitors/setting/kakao-alimtalk", data);
        return { success: res.data.result };
    } catch (error) {
        Sentry.captureException(error, { extra: data });
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
    }
};
